import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=2951373a&"
import script from "./IconDelete.vue?vue&type=script&lang=ts&"
export * from "./IconDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports